import React from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import { connect } from 'react-redux';

class DeleteSMTPConfigModal extends React.Component {
  remove = () => {
    fetch('/api/config/set_db_config?id=' + this.props.fileid, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ settingsId: this.props.settingsId }),
    })
      .then((response) => {
        if (response.ok) {
          this.props.refresh();
        } else {
          console.error('Failed to delete SMTP configuration');
        }
      })
      .catch((error) => {
        console.error('Error occurred during the delete request:', error);
      })
      .finally(() => {
        this.props.toggle();
      });
  };

  render() {
    const { localisation } = this.props.userReducer;

    return (
      <div>
        <Modal
          isOpen={this.props.visible}
          toggle={this.props.toggle}
          className={this.props.className}
        >
          <ModalHeader toggle={this.props.toggle}>
            {localisation['delete_pollers_header']
              ? localisation['delete_pollers_header'].element_lang
              : 'Delete SMTP Server'}
          </ModalHeader>
          <ModalBody>
            <Label size={10}>
              Are you sure you wish the remove the selected SMTP Server?
            </Label>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={() => this.remove()}>
              Delete
            </Button>{' '}
            <Button color="secondary" onClick={this.props.toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default connect((state) => state)(DeleteSMTPConfigModal);
